import { render, staticRenderFns } from "./nothing.vue?vue&type=template&id=c9dc9222&scoped=true&"
import script from "./nothing.vue?vue&type=script&lang=js&"
export * from "./nothing.vue?vue&type=script&lang=js&"
import style0 from "./nothing.vue?vue&type=style&index=0&id=c9dc9222&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9dc9222",
  null
  
)

export default component.exports